<template>
  <div class="container" :class="isMenuCollapse? 'hidemenu' : ''">
    <!-- 左边 -->
    <div class="left-container">

      <div class="menu-box">
        <!-- 切换菜单按钮 -->
        <hamburger :is-active="isMenuCollapse" class="hamburger-container" @toggleClick="toggleSideBar" />

        <el-input placeholder="请输入内容" size="small" v-model="search" clearable v-if="!isMenuCollapse" style="width:96%;"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
        <div class="title-box">
          <span v-if="!isMenuCollapse">表名</span>
          <i class="el-icon-circle-plus-outline icon" title="新建表" @click="handleAddMenu"></i>
        </div>
      </div>
      <div class="menu-list">
        <el-scrollbar ref="scroll" wrap-class="scrollbar-wrapper">
          <el-menu :default-active="activeName" :collapse="isMenuCollapse" :collapse-transition="false" mode="vertical" @select="handleSelect">
            <menu-item @getflg='getflgfn' v-for="item in menuOptions" :key="item.id" :isMenuCollapse="isMenuCollapse" :item="item" :renewList="getMenu" />
          </el-menu>
        </el-scrollbar>
      </div>
    </div>

    <!-- 右边 -->
    <div class="main">
      <!-- 内容区域 -->
      <content-table ref="content" @openCode="handleSelectCode" @renewList="getMenu"></content-table>
    </div>

    <!-- 新增菜单弹窗 -->
    <el-dialog class="dialog" :title="ifupdate?'编辑中间表':'创建中间表'" v-if="dialogAddMenu" :visible.sync="dialogAddMenu" :close-on-click-modal="false" @close="handleReturn" width="1000px" top="10vh">
      <el-steps :active="stepsActive" finish-status="success" align-center>
        <el-step title="设置基础信息"></el-step>
        <el-step title="设置规则"></el-step>
        <el-step :title="ifupdate?'编辑完成':'创建完成'"></el-step>
      </el-steps>
      <!-- 第一步 -->
      <template v-if="stepsActive == 1">
        <el-form :model="menuAddForm" :rules="ruleAddForm" ref="menuAddForm" label-width="120px" style="margin-top:20px">

          <el-form-item label="表名：" prop="eventName">
            <!-- <span class="label">vt$</span> -->
            <el-input size="small" v-model="menuAddForm.eventName" placeholder="字母开头，可含字母、数字、下划线" style="width: 300px" :disabled="ifupdate">
              <template slot="prepend">vt$</template>
            </el-input>
            <!-- <el-popover placement="top-start" width="400" trigger="hover" content="vt$用于标示该中间表为用户自定义创建的虚拟中间表">
                            <i slot="reference" class="el-icon-warning"></i>
                        </el-popover> -->
          </el-form-item>

          <el-form-item label="显示名称：" prop="eventDesc">
            <el-input size="small" v-model="menuAddForm.eventDesc" placeholder="" style="width: 300px"></el-input>
          </el-form-item>

          <el-form-item label="所属游戏：" prop="appkey" class="box-card">
            <el-select class="filter-item" size="small" v-model="menuAddForm.appkey" multiple collapse-tags filterable clearable style="width:300px;" @change="selectAll">
              <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否显示：" prop="isRead">
            <el-switch v-model="menuAddForm.isRead" size="mini" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>

          <el-form-item label="时间维度：" prop="dateType">
            <el-radio-group v-model="menuAddForm.dateType">
              <el-radio disabled v-for="item in dateTypeOptions" :key="item.id" :label="item.id">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="数据更新方式：" prop="updateType">
            <el-radio-group v-model="menuAddForm.updateType">
              <el-radio v-for="item in updateTypeOptions" :key="item.id" :label="item.id" :disabled="ifupdate">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注：">
            <el-input type="textarea" v-model="menuAddForm.desc"></el-input>
          </el-form-item>
        </el-form>

        <!-- 按钮组 -->
        <div class="butn-box" style="text-align: right">
          <el-button size="small" @click="handleReturn">取消</el-button>
          <el-button size="small" type="primary" @click="handleNextStep">下一步</el-button>
        </div>
      </template>

      <!-- 第二步 -->
      <condition-form ref="condition" v-if="stepsActive == 2" :sourceData="ruleData" :selectProps="selectProps" :whereProps="whereProps" :symbolOption="symbolOption" @changeEvent="getSelectData" @jump="handleJump"
        style="margin-top:20px" :ifupdate="ifupdate" v-loading="addloading" :element-loading-text="ifupdate?'拼命编辑中':'拼命创建中'">
      </condition-form>

      <!-- 第三步 -->
      <template v-if="stepsActive == 3">
        <div class="complete-box">
          <i class="el-icon-circle-check check"></i>
          <span class="tips" v-if="ifupdate">中间表编辑完成</span>
          <span class="tips" v-if="!ifupdate">中间表创建完成</span>

          <div class="copy-box">
            <div class="list">
              <div class="title">中间表名称：</div>
              <div class="content">{{eventDesc}}</div>
              <!-- <el-button class="butn" size="mini" type="primary"></el-button> -->
              <el-button size="mini" v-clipboard:copy="eventDesc" v-clipboard:success="clipboardSuccess" type="primary" icon="el-icon-document">复制</el-button>
            </div>
            <div class="list">
              <div class="title">中间表字段：</div>
              <div class="content">{{fields}}</div>
            </div>
          </div>

          <el-button size="small" type="primary" @click="handleReturn">返回列表查看</el-button>
        </div>

      </template>

    </el-dialog>

  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger'
import MenuItem from './components/menuItem-single.vue'
import ContentTable from './components/contentTable-single.vue'
import ConditionForm from './components/conditionForm.vue'
// import clip from '@Sys~/utils/clipboard'
import clipboard from '@/directive/clipboard/index.js'
import { managenewList, ajax_filterGame, managenewEvents, managenewEventCode, managenewWhereCode, createManagenew, managenewInfo } from '@Sys~/api/sys'

// 弹窗默认的数据内容
const defaultFrom = {
  appkey: "",
  dateType: 1,
  desc: "",
  eventDesc: "",
  eventName: "",
  isRead: true,
  updateType: '',
  updateJson: '',
  rule: {} // 二级
}


export default {
  components: { Hamburger, MenuItem, ContentTable, ConditionForm },
  data() {
    return {
      isMenuCollapse: false, // 导航栏是否打开
      // 菜单列表
      menuData: [],
      originalMenuData: [],
      groupOptions: [], // 所有组名
      activeName: null, // 当前激活菜单

      search: '', // 搜索

      // 创建菜单弹窗 ^[0-9a-zA-Z_]{1,}$
      dialogAddMenu: false,
      stepsActive: 1,
      menuAddForm: {},
      ruleAddForm: {
        eventName: { required: true, message: '请填写正确表名：字母开头，包含字母、数字、下划线', trigger: ['change', 'blur'], pattern: /^[0-9a-zA-Z_]{1,}$/ },
        eventDesc: [{ required: true, message: '请填写显示名称', trigger: ['change', 'blur'] }],
        appkey: { required: true, message: '请选择游戏', trigger: ['change', 'blur'] },
        isRead: { required: true, message: '请选择是否显示', trigger: ['change', 'blur'] },
        dateType: { required: true, message: '请选择时间维度', trigger: ['change', 'blur'] },
        updateType: { required: true, message: '请选择数据更新方式', trigger: ['change', 'blur'] },
      },
      gameOptions: [], // 游戏列表
      oldChooseData: [],//全选所用
      dateTypeOptions: [{ id: 0, name: '时表' }, { id: 1, name: '日表' }, { id: 3, name: '周表' }], // 时间维度
      updateTypeOptions: [{ id: 0, name: '手动' }, { id: 1, name: '自动' }], // 更新方式

      // 第二步数据
      ruleData: {},
      selectProps: {
        expandTrigger: 'hover',
        multiple: true,
        checkStrictly: true
      },
      whereProps: {
        expandTrigger: 'hover',
        checkStrictly: true
      },
      symbolOption: [
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "ge",
          label: "大于等于"
        },
        {
          value: "le",
          label: "小于等于"
        },
        {
          value: "ne",
          label: "不等于"
        },
        {
          value: "range",
          label: "区间"
        }
      ],

      recordRule: {},

      eventDesc: '', // 中间表名称
      fields: '', // 中间表字段

      eventCode: '',//编辑时所需eventCode

      ifupdate: false,

      addloading: false,
    }
  },
  directives: {
    clipboard
  },
  computed: {
    // 模糊搜索 菜单
    menuOptions() {
      const search = this.search.replace(/^\s+|\s+$/g, "")
      this.menuData = JSON.parse(JSON.stringify(this.originalMenuData))
      if (search) {
        return this.menuData.filter(menu => {
          return String(menu['eventName']).toLowerCase().indexOf(search) >= 0 || String(menu['eventDesc']).toLowerCase().indexOf(search) >= 0
        })
      }
      // console.log('========33333',this.menuData)
      return this.menuData
    }
  },

  created() {
    this.getMenu() // 获取菜单列表
  },

  methods: {
    getflgfn(obj) {
      this.ifupdate = obj.flg;
      this.eventCode = obj.eventCode;
      console.log(this.eventCode)
      managenewInfo(this.eventCode).then(response => {
        if (response.code == 1) {
          console.log(response.data)
          // if(response.data.updateJson && JSON.parse(response.data.updateJson) != '{}' && response.data.updateJson != null && response.data.updateJson != ""){
          if (true) {
            this.getGameList()
            var updateJson = JSON.parse(response.data.updateJson)
            console.log(updateJson)
            this.menuAddForm = updateJson
            this.ruleData = updateJson.ruleData
            this.recordRule = updateJson.ruleData

            this.ruleData.events.forEach(events => {
              events.selectData.forEach(selectData => {
                events.selectList.forEach(selectList => {
                  if (selectData.dataKey == selectList.value) {
                    selectList.disabled = true
                  }
                })
              })
            })

            this.dialogAddMenu = true
            this.stepsActive = 1
          } else {
            this.$message.error("此表尚不可编辑，如有疑问请联系管理员！");
          }

        }
      })
      // this.$nextTick(() => {
      //   this.$refs['menuAddForm'].clearValidate()
      //   this.getGameList() // 获取游戏列表
      // })
    },
    // 获取菜单列表
    getMenu() {
      managenewList().then(response => {
        if (response.code == 1) {
          const data = JSON.parse(JSON.stringify(response.data))
          this.originalMenuData = data.map(v => {
            this.$set(v, 'edit', false)
            this.$set(v, 'originalName', v.eventDesc)
            return v
          })
          this.menuData = this.originalMenuData

          this.activeName = this.menuData[0].eventCode // 筛选默认的 eventCode
          this.$refs['content'].getList(this.activeName) // 初始化详情

        }
      })
    },

    // 新增菜单
    handleAddMenu() {
      this.menuAddForm = JSON.parse(JSON.stringify(defaultFrom)) // 深复制
      this.dialogAddMenu = true
      this.stepsActive = 1
      this.ifupdate = false;
      this.$nextTick(() => {
        this.$refs['menuAddForm'].clearValidate()
        this.getGameList() // 获取游戏列表
      })
    },

    // 获取游戏列表
    getGameList() {
      ajax_filterGame().then(response => {
        if (response.code == 1) {
          response.data.unshift({
            appkey: "",
            name: "全选"
          });
          this.gameOptions = response.data
        }
      })
    },

    // 操作下一步
    handleNextStep() {
      this.$refs['menuAddForm'].validate((valid) => {
        if (valid) {
          // console.log('第一步数据格式：',this.menuAddForm)
          console.log('第er步数据格式：', this.ruleData)
          this.stepsActive = 2
          if (JSON.stringify(this.ruleData) == '{}') {
            this.$nextTick(() => {
              this.$refs['condition'].$refs['ruleForm'].clearValidate()
              this.ruleData = {
                events: [
                  {
                    eventCode: '',
                    platformType: '',
                    tableId: '',
                    selectData: [],
                    whereData: {
                      type: 'AND',
                      data: []
                    },
                    eventValue: [],
                    seletedValue: [],
                    selectList: [],
                    whereList: []
                  },
                  {
                    eventCode: '',
                    platformType: '',
                    tableId: '',
                    selectData: [],
                    whereData: {
                      type: 'AND',
                      data: []
                    },
                    eventValue: [],
                    seletedValue: [],
                    selectList: [],
                    whereList: []
                  }
                ],
                joins: [],

                "executeType": "left join",
                "leftIndex": 1,
                "outputMode": "overwrite",
                "rightIndex": 2,

                eventsList: [],
                joinsList_1: [],
                joinsList_2: []
              }

              this.getEvents() // 获取分析对象 events 列表
            })
          } else {
            this.$nextTick(() => {
              this.ruleData = JSON.parse(JSON.stringify(this.recordRule))
              this.getEvents() // 获取分析对象 events 列表
            })
          }
        }
      })
    },

    // 获取分析对象 events 列表
    getEvents() {
      managenewEvents(this.menuAddForm.appkey).then(response => {
        if (response.code == 1) {
          this.ruleData.eventsList = response.data
        }
      })
    },

    // 获取 分析对象 select 列表
    getSelectData(item, index) {
      // selected 列表
      managenewEventCode(item.data.value, item.data.platformType, 1).then(response => {
        if (response.code == 1) {

          response.data.forEach(item => {
            if (item.label == "" || item.label == null) {
              item.label = item.value
            }
          })

          this.ruleData.events[index].selectList = response.data
        }
      })

      // where 列表
      managenewWhereCode(item.data.value, item.data.platformType, 1).then(response => {
        if (response.code == 1) {
          response.data.forEach(item => {
            if (item.label == "" || item.label == null) {
              item.label = item.value
            }
          })
          const data = JSON.parse(JSON.stringify(response.data))
          this.ruleData.events[index].whereList = data.map(v => {
            if (v.children && v.children.length == 0) {
              v.children = null
            }

            return v
          })
        }
      })

      // joins 列表
      managenewEventCode(item.data.value, item.data.platformType, 0).then(response => {
        if (response.code == 1) {
          response.data.forEach(item => {
            if (item.label == "" || item.label == null) {
              item.label = item.value
            }
          })
          const data = JSON.parse(JSON.stringify(response.data))


          if (index == 0) {
            this.ruleData.joinsList_1 = data.map(v => {
              if (v.children && v.children.length == 0) {
                v.children = null
              }

              return v
            })
          } else {
            this.ruleData.joinsList_2 = data.map(v => {
              if (v.children && v.children.length == 0) {
                v.children = null
              }
              return v
            })

          }
        }
      })
    },

    // 跳转上一步下一步
    handleJump(para, data) {
      if (para == 'upper') { // 上一步
        this.stepsActive = 1
        this.recordRule = JSON.parse(JSON.stringify(this.ruleData))
        // console.log('====', this.recordRule)
      } else if (para == 'lower') { // 下一步
        this.$refs['condition'].$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.addloading = true;
            var alldata = JSON.parse(JSON.stringify(this.menuAddForm))
            alldata.ruleData = JSON.parse(JSON.stringify(data))
            alldata.ruleData.eventsList = []
            console.log(JSON.stringify(alldata))

            // 创建中间表
            const returnData = JSON.parse(JSON.stringify(data))
            let result = {
              leftIndex: returnData.leftIndex,
              executeType: returnData.executeType,
              rightIndex: returnData.rightIndex,
              outputMode: returnData.outputMode,
              joins: returnData.joins,
              events: [],

            }

            returnData.events.forEach(event => {
              const data = {
                eventCode: event.eventCode,
                platformType: event.platformType,
                tableId: event.tableId,
                selectData: event.selectData,
                whereData: event.whereData
              }
              data.whereData.data.forEach(whereItem => {
                whereItem.data.forEach(dataItem => {
                  this.$delete(dataItem, 'inputValue')
                  this.$delete(dataItem, 'whereValue')
                })
              })

              result.events.push(data)
            })

            result.joins.forEach(join => {
              join.forEach(item => {
                this.$delete(item, 'joinValue')
              })
            })

            this.menuAddForm.rule = result

            delete this.menuAddForm.ruleData;

            this.menuAddForm.updateJson = JSON.stringify(alldata);

            if (this.ifupdate) {
              this.menuAddForm.eventCode = this.eventCode
            }

            console.log(JSON.stringify(this.menuAddForm))
            createManagenew(this.menuAddForm).then(response => {
              if (response.code == 1) {
                this.stepsActive = 3
                this.eventDesc = this.menuAddForm.eventDesc // 表名
                this.fields = response.data.join(',')
              }
              this.addloading = false;
            })
          }
        })
      }
    },

    // 返回列表
    handleReturn() {
      // console.log('===关闭弹窗回调')
      this.dialogAddMenu = false
      this.menuAddForm = {}
      this.ruleData = {}
      this.recordRule = {}
      this.getMenu() // 获取菜单列表
    },

    // 拷贝
    clipboardSuccess() {
      this.$message({
        message: '拷贝成功',
        type: 'success',
        duration: 1500
      })
    },

    // 切换导航
    toggleSideBar() {
      this.isMenuCollapse = !this.isMenuCollapse
    },

    // 切换菜单
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeName = key
      this.$refs['content'].getList(key) // 初始化详情
    },

    // 切换菜单 并 定位到头部
    handleSelectCode(key) {
      this.activeName = key
      this.$refs['content'].getList(key) // 初始化详情

      const menu = this.$refs['scroll'].wrap
      let currentIndex = 0
      this.menuOptions.forEach((item, index) => {
        if (item.eventCode == key) {
          currentIndex = index
        }
      })
      // console.log(currentIndex)
      // console.log(this.$refs['scroll'])
      menu.scrollTop = currentIndex * 30
    },
    selectAll(val) {
      const allValues = this.gameOptions.map(item => {
        return item.appkey;
      });
      // 用来储存上一次选择的值，可进行对比
      const oldVal = this.oldChooseData.length > 0 ? this.oldChooseData : [];

      // 若选择全部
      if (val.includes('')) {
        this.menuAddForm.appkey = allValues;
      }

      // 取消全部选中， 上次有， 当前没有， 表示取消全选
      if (oldVal.includes('') && !val.includes('')) {
        this.menuAddForm.appkey = [];
      }

      // 点击非全部选中，需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.includes('') && val.includes('')) {
        const index = val.indexOf('');
        val.splice(index, 1); // 排除全选选项
        this.menuAddForm.appkey = val;
      }

      // 全选未选，但是其他选项都全部选上了，则全选选上
      if (!oldVal.includes('') && !val.includes('')) {
        if (val.length === allValues.length - 1) {
          this.menuAddForm.appkey = [''].concat(val);
        }
      }
      // 储存当前选择的最后结果 作为下次的老数据
      this.oldChooseData = this.menuAddForm.appkey;
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  position: relative;
  transition: 0s width ease-in-out, 0s padding-left ease-in-out,
    0s padding-right ease-in-out;
}
// 左边
.left-container {
  transition: width 0.28s;
  width: 240px;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 100px;
  bottom: 0;
  left: 225px;
  z-index: 9;
  border-right: 1px solid #e6e6e6;

  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
    width: 100%;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }

  .el-menu {
    border: none;
    height: 100%;
  }

  .menu-list {
    width: 100%;
    height: calc(100vh - 190px);
    overflow: hidden;
  }

  .menu-box {
    width: 100%;
    text-align: center;
    position: relative;

    .hamburger-container {
      position: absolute;
      top: -19px;
      right: -30px;
      cursor: pointer;
    }
    .title-box {
      width: 100%;
      height: 30px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding: 0 20px;
      background: #dfe6ec;
      transition: width 0.28s;
      span {
        font-size: 14px;
        opacity: 1;
        transition: 0s width ease-in-out, 0s padding-left ease-in-out,
          0s padding-right ease-in-out;
      }
    }
  }

  .icon {
    font-size: 18px;
    font-weight: bolder;
    cursor: pointer;
    color: #409eff;
  }
}

// 右边
.main {
  min-height: 100%;
  height: auto;
  transition: all 0.28s;
  margin-left: 240px;
  position: relative;
  z-index: 1;
  padding: 10px 20px;
}

// 折叠侧边栏后
.hidemenu {
  .left-container {
    width: 40px !important;
    top: 90px;
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
    .menu-list {
      height: calc(100vh - 118px);
    }
    .title-box {
      justify-content: center;
      span {
        transition: opacity 5s;
        opacity: 0;
      }
    }
  }

  .el-menu--collapse {
    width: 39px !important;
  }

  .main {
    margin-left: 40px;
  }
}

// 侧边栏折叠
.hideSidebar {
  .left-container {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
    left: 69px !important;
  }
}

// 弹窗
.dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 20px;
    height: auto;
    max-height: calc(100vh - 25vh);
    overflow: auto;
  }

  .complete-box {
    margin-top: 20px;
    padding: 10px 0 20px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .check {
      font-size: 60px;
      color: #67c23a;
      margin: 10px 0;
    }
    .tips {
    }

    .copy-box {
      margin: 20px 0;
      padding: 10px;
      background: #dbdfe7;
      .list {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 2;
        .title {
          color: #7d7d7d;
        }
        .content {
          margin: 0 20px 0 10px;
        }

        .butn {
          padding: 3px 8px;
        }
      }
    }
  }
}

.box-card {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 84%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
}
</style>